var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51436 15.9998L6.69436 14.8178C7.07236 14.4398 7.28036 13.9378 7.28036 13.4038V8.72683C7.28036 7.36983 7.87036 6.07283 8.90036 5.17083C9.93836 4.26083 11.2604 3.86083 12.6374 4.04183C14.9644 4.35083 16.7194 6.45483 16.7194 8.93683V13.4038C16.7194 13.9378 16.9274 14.4398 17.3044 14.8168L18.4854 15.9998H5.51436ZM13.9994 18.3408C13.9994 19.2398 13.0834 19.9998 11.9994 19.9998C10.9154 19.9998 9.99936 19.2398 9.99936 18.3408V17.9998H13.9994V18.3408ZM20.5204 15.2078L18.7194 13.4038V8.93683C18.7194 5.45583 16.2174 2.49883 12.8994 2.05983C10.9774 1.80383 9.03736 2.39083 7.58236 3.66683C6.11836 4.94883 5.28036 6.79283 5.28036 8.72683L5.27936 13.4038L3.47836 15.2078C3.00936 15.6778 2.87036 16.3768 3.12436 16.9898C3.37936 17.6038 3.97236 17.9998 4.63636 17.9998H7.99936V18.3408C7.99936 20.3588 9.79336 21.9998 11.9994 21.9998C14.2054 21.9998 15.9994 20.3588 15.9994 18.3408V17.9998H19.3624C20.0264 17.9998 20.6184 17.6038 20.8724 16.9908C21.1274 16.3768 20.9894 15.6768 20.5204 15.2078Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlack);
export default __webpack_public_path__ + "static/media/BellBlack.4c9d578ab8e23775a960c62f160fe1a4.svg";
export { ForwardRef as ReactComponent };